import axios from 'axios';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import Url from '../../apiBaseUrl/APIConfig';
import type { SchemeListResponse } from './Model';
import { setupInterceptorsTo } from '../authenticationInterceptors/Interceptors';

type InitialState = {
  loading: boolean;
  schemeListRes: SchemeListResponse;
  error: string;
};

const initialState: InitialState = {
  loading: false,
  schemeListRes: {} as SchemeListResponse,
  error: '',
};

export const getSchemeList = createAsyncThunk<SchemeListResponse, void>(
  'getSchemeList/getSchemeList',
  async (_, { rejectWithValue }) => {
    const headers = {
      Accept: 'application/json',
      'Content-type': 'application/json',
      Authorization: 'Token 3703265d357a211:5b86c8948ff269d',
    };
    try {
      // The GET request with query parameters
      const response = await setupInterceptorsTo(axios).get(
        `${Url.erpBaseUrl}/api/resource/Cost Center`,
        {
          headers: headers,
          params: {
            // Arrays/Objects must be stringified for Frappe/ERPNext API
            fields: JSON.stringify(['name']),
            filters: JSON.stringify([
              ['disabled', '=', '0'],
              ['is_group', '=', '0'],
            ]),
          },
          withCredentials: true,
        },
      );

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || 'Something went wrong');
    }
  },
);

const getSchemeListSlice = createSlice({
  name: 'getSchemeList',
  initialState,
  reducers: {
    clearSchemeList: (state) => {
      state.schemeListRes = {} as SchemeListResponse;
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSchemeList.pending, (state) => {
      state.loading = true;
      state.error = '';
    });
    builder.addCase(getSchemeList.fulfilled, (state, action: PayloadAction<SchemeListResponse>) => {
      state.loading = false;
      state.schemeListRes = action.payload;
    });
    builder.addCase(getSchemeList.rejected, (state, action) => {
      state.loading = false;
      state.error = String(action.payload) || 'Something went wrong';
    });
  },
});

export const { clearSchemeList } = getSchemeListSlice.actions;
export default getSchemeListSlice.reducer;
